<template>
  <div class="wrapper">
    <!-- <div>sss</div> -->
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
        </b-col>
      </b-row>
      <b-form @submit.prevent="saveItem">
        <b-row>
          <b-col cols="12">
            <b-card no-body>
              <template v-slot:header>
                <span class="pull-left mt-2 mb-2"><strong>Groep: {{ item.name }}</strong></span>
                <b-button class="pull-right" variant="primary" v-if="!editable" @click="editable = true"
                          size="sm">Bewerken
                </b-button>
                <b-button type="submit" variant="success" class="float-right" size="sm"
                          :disabled="saveButtonDisabled" v-if="editable">Wijzigingen opslaan
                </b-button>
                <b-button @click.prevent="cancelEdit" class="float-right mr-3" v-if="editable" size="sm">
                  Annuleren
                </b-button>
              </template>
              <b-row class="mt-3 mb-3">
                <b-col cols="12">
                  <b-col>
                    <b-form-group label="Groepsnaam">
                      <b-form-input type="text" required v-model="item.name" :disabled="!editable"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col class="mb-2">
                    <div class="d-flex justify-content-between">
                      <span class="align-left"><strong>Gekoppelde SF Relaties</strong></span>
                      <span>
                      <b-button size="sm" v-b-modal.add-accounts>SF Relatie(s) toevoegen</b-button>
                    </span>
                    </div>
                  </b-col>
                  <b-col>
                    <b-form-group>
                      <table v-if="item.accounts" class="table table-sm">
                        <tbody>
                        <tr v-for="account in item.accounts">
                          <td>{{ account.name }}</td>
                          <td><a href="#" @click="removeAccount(account.id)" class="text-danger">Verwijder uit groep</a>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <p v-if="item.accounts.length === 0"><em>Er zijn nog geen SF Relaties toegevoegd aan deze
                        groep</em></p>
                    </b-form-group>
                  </b-col>
                  <b-col class="mb-2">
                    <div class="d-flex justify-content-between">
                      <span class="align-left"><strong>Gekoppelde SF Contactpersonen</strong></span>
                      <span>
                      <b-button size="sm" v-b-modal.add-contacts>SF Contactperson(en) toevoegen</b-button>
                    </span>
                    </div>
                  </b-col>
                  <b-col>
                    <b-form-group>
                      <table v-if="item.contacts" class="table table-sm">
                        <tbody>
                        <tr v-for="contact in item.contacts">
                          <td>{{ contact.name }}</td>
                          <td><a href="#" @click="removeContact(contact.id)" class="text-danger">Verwijder uit groep</a>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <p v-if="item.contacts.length === 0"><em>Er zijn nog geen SF Contactpersonen toegevoegd aan deze
                        groep</em></p>
                    </b-form-group>
                  </b-col>

                  <b-col class="mb-2">
                    <div class="d-flex justify-content-between">
                      <span class="align-left"><strong>Gekoppelde Projectintroducties</strong></span>
                      <span>
                      <b-button size="sm" v-b-modal.add-projectintroductions>Projectintroductie(s) toevoegen</b-button>
                    </span>
                    </div>
                  </b-col>
                  <b-col>
                    <b-form-group>
                      <table v-if="item.project_introductions" class="table table-sm">
                        <tbody>
                        <tr v-for="introduction in item.project_introductions">
                          <td>{{ introduction.title }}</td>
                          <td><a href="#" @click="removeProjectIntroduction(introduction.id)" class="text-danger">Verwijder uit groep</a>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <p v-if="item.projects.length === 0"><em>Er zijn nog geen SF projecten toegevoegd aan deze groep</em></p>
                    </b-form-group>
                  </b-col>

                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </div>

    <b-modal id="add-accounts" title="SF Relatie(s) toevoegen">
      <multiselect v-model="accounts.value" :options="filteredAccounts" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="false">
        <template v-slot:selection="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
      </multiselect>

      <b-button variant="primary" size="sm" @click="addAccounts" style="margin-top: 10px;">SF Relatie(s) toevoegen</b-button>
    </b-modal>

    <b-modal id="add-contacts" title="SF Contactperson(en) toevoegen">
      <multiselect v-model="contacts.value" :options="filteredContacts" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="false">
        <template v-slot:selection="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
      </multiselect>

      <b-button variant="primary" size="sm" @click="addContacts" style="margin-top: 10px;">SF Contactperson(en) toevoegen</b-button>
    </b-modal>

    <b-modal id="add-projectintroductions" title="Projectintroductie(s) toevoegen">
      <multiselect v-model="projectIntroductions.value" :options="filteredProjectIntroductions" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="name" track-by="name" :preselect-first="false">
        <template v-slot:selection="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
      </multiselect>

      <b-button variant="primary" size="sm" @click="addProjectIntroductions" style="margin-top: 10px;">Projectintroductie(s) toevoegen</b-button>
    </b-modal>

  </div>
</template>
<script>
import {deleteItem, getData, updateData} from '@/api';
import ProjectParticipations from "@/views/projects/parts/Participations";
import ProjectUpdates from "@/views/projects/parts/Updates";
import ProjectKeyData from "@/views/projects/parts/KeyData";
import ProjectFases from "@/views/projects/parts/Fases";
import Multiselect from 'vue-multiselect'
import {addData} from "../../api";

export default {
  name: 'project',
  components: {ProjectFases, ProjectKeyData, ProjectUpdates, ProjectParticipations, Multiselect},
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      editable: false,
      companyOptions: [],
      countryOptions: [],
      item: [],
      errors: null,

      accounts: {
        value: [],
        options: []
      },

      contacts: {
        value: [],
        options: []
      },

      projectIntroductions: {
        value: [],
        options: []
      },
    }
  },
  methods: {
    async getItem() {
      const item = await getData('groups/' + this.$route.params.id).then(response => response.data);
      this.item = item.data
    },

    async getAccounts() {
      const item = await getData('accounts/select').then(response => response.data);

      this.accounts.options = item.map(item => {
        return {
          name: item.text,
          id: item.value
        }
      }).filter(item => item.id !== null);
    },

    async getContacts() {
      const item = await getData('accounts/contacts/select').then(response => response.data);

      this.contacts.options = item.map(item => {
        return {
          name: item.text,
          id: item.value
        }
      }).filter(item => item.id !== null);
    },

    async getProjectIntroductions() {
      const item = await getData('project-introductions/select').then(response => response.data);

      this.projectIntroductions.options = item.map(item => {
        return {
          name: item.text,
          id: item.value
        }
      }).filter(item => item.id !== null);
    },

    async saveItem() {
      // console.log(this.item.name)
      this.errors = null;
      this.saveButtonDisabled = true;
      const request = await updateData('groups/' + this.$route.params.id, {
        'name': this.item.name,
      });
      // console.log(request.status)
      //  console.log(data)
      if (request.status === 200) {

        this.item = request.data.data;

        this.feedback.text = 'Gebruiker succesvol geupdate';
        this.feedback.variant = 'success';
        this.editable = false;
        this.saveButtonDisabled = false;
      } else {
        this.errors = request.data.errors;
        this.feedback.show = true;
        this.feedback.text = 'Er ging iets mis...';
        this.feedback.variant = 'danger';
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },

    cancelEdit() {
      this.editable = false;
      this.getItem();
    },

    countDownChanged(dismissCountDown) {
      this.feedback.dismissCountDown = dismissCountDown
    },

    showAlert() {
      this.this.feedback.dismissCountDown = this.dismissSecs
    },

    async addAccounts() {
      addData(`groups/${this.$route.params.id}/addAccounts`, {
        ids: this.accounts.value.map(item => item.id)
      }).then(response => {
        this.item = response.data.data

        this.$bvModal.hide('add-accounts');

        this.accounts.value = [];
      })
    },

    async removeAccount(id) {
      deleteItem(`groups/${this.$route.params.id}/removeAccount/${id}`).then(response => this.item = response.data.data)
    },

    async addContacts() {
      addData(`groups/${this.$route.params.id}/addContacts`, {
        ids: this.contacts.value.map(item => item.id)
      }).then(response => {
        this.item = response.data.data

        this.$bvModal.hide('add-contacts');

        this.contacts.value = [];
      })
    },

    async removeContact(id) {
      deleteItem(`groups/${this.$route.params.id}/removeContact/${id}`).then(response => this.item = response.data.data)
    },

    async addProjectIntroductions() {
      addData(`groups/${this.$route.params.id}/addProjectIntroductions`, {
        ids: this.projectIntroductions.value.map(item => item.id)
      }).then(response => {
        this.item = response.data.data

        this.$bvModal.hide('add-projectintroductions');

        this.projectIntroductions.value = [];
      })
    },

    async removeProjectIntroduction(id) {
      deleteItem(`groups/${this.$route.params.id}/removeProjectIntroduction/${id}`).then(response => this.item = response.data.data)
    },

  },

  computed: {
    filteredAccounts() {
      return this.accounts.options.filter(item => {
        return this.item.accounts.filter(subitem => subitem.id === item.id).length === 0
      })
    },

    filteredContacts() {
      return this.contacts.options.filter(item => {
        return this.item.contacts.filter(subitem => subitem.id === item.id).length === 0
      })
    },

    filteredProjectIntroductions() {
      return this.projectIntroductions.options.filter(item => {
        return this.item.project_introductions.filter(subitem => subitem.id === item.id).length === 0
      })
    }
  },

  beforeMount() {
    this.getItem();
    this.getAccounts();
    this.getContacts();
    this.getProjectIntroductions();
  },
}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
